// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import Formatter from '../../../../i18n/formatter';
import { __, getCurrency } from '../../../../i18n/l10n';
import NumberFormatter from '../../../../i18n/numberformatter';
import BoomUIBySkinId from '../../constants/ui';
import { useBoomContext } from '../../contexts/BoomContext';
import BoomBoxWrapper from '../common/BoomBoxWrapper';

const Wrapper = styled(BoomBoxWrapper)`
  padding: 0.7em;

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;

  ${({ $skinId }) => {
    const textStyle = BoomUIBySkinId[$skinId]?.TEXT_STYLE;

    return css`
      color: ${textStyle?.color};
    `;
  }}
`;

const ListItem = styled.div`
  display: inline-flex;

  &:not(:last-child) {
    margin-bottom: 0.7em;
  }
`;

const Circle = styled.div`
  margin-top: 0.4em;

  height: 0.6em;
  width: 0.6em;
  border-radius: 50%;

  flex-shrink: 0;

  ${({ $skinId }) => {
    const textStyle = BoomUIBySkinId[$skinId]?.TEXT_STYLE;

    return css`
      background-color: ${textStyle?.lockedColor};
    `;
  }}
`;

const ListItemContent = styled.div`
  margin-left: 0.7em;
`;

type PropsType = {
  className?: string;
  minBetOdds?: number;
  stakeMultiplier?: number;
  stakeMaxRefAmount?: number;
  isLocked?: boolean;
};

// __('Reference bet: the smallest bet of the levels you have won (max %1$s)')

const BoomStepInfo = ({
  className = '',
  minBetOdds = 0,
  stakeMultiplier = 1,
  stakeMaxRefAmount = 20,
  isLocked = false,
}: PropsType) => {
  const { skinId } = useBoomContext();

  return (
    <Wrapper className={className} skinId={skinId} $skinId={skinId}>
      {isLocked ? (
        <ListItem>
          <Circle $skinId={skinId} />
          <ListItemContent>{__('Win all previous levels in order to unlock this level')}</ListItemContent>
        </ListItem>
      ) : null}
      <ListItem>
        <Circle $skinId={skinId} />
        <ListItemContent>
          {__('Minimum odds to win this level: %1$s', NumberFormatter.formatOdd(minBetOdds))}
        </ListItemContent>
      </ListItem>
      {typeof stakeMultiplier === 'number' ? (
        <ListItem>
          <Circle $skinId={skinId} />
          <ListItemContent>
            {__('Freebet winnings if you win this level: Reference bet x %1$s', stakeMultiplier)}
          </ListItemContent>
        </ListItem>
      ) : null}
      <ListItem>
        <Circle $skinId={skinId} />
        <ListItemContent>
          {__(
            'Reference bet: the smallest bet of the levels you have won (max %1$s)',
            Formatter.formatNumber(stakeMaxRefAmount, getCurrency(), true),
          )}
        </ListItemContent>
      </ListItem>
    </Wrapper>
  );
};

export default BoomStepInfo;
